import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { SignInPageService } from '@pages/SignInPage/services';
import { StorageModule } from '@vlinder-web/storage-module-react';
import toast from 'react-hot-toast';

const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

export const getAccessToken = async (context: any, event: any) => {
  const currentState = 'GET_ACCESS_TOKEN';
  const method = 'getAccessToken';
  const storageSrv = StorageModule.getInstance();

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);

      /*Impliict Admin Role Selection */

      const signInRes = context['signInRes'];
      const _role =
        Array.isArray(signInRes?.userRoles) &&
        signInRes?.userRoles?.find((item: any) => item?.name === 'purchaser');

      if (!_role || !_role?.uuid) {
        log.error(MODULE_NAME, `error in ${method}: no 'purchaser' role found in userRoles`);
        toast.error('Login failed: user does not have the required role.');
        return reject({
          key: 'SIGN_IN_USER_FAILED',
          value: "No 'purchaser' role found",
        });
      }

      const _args = {
        jwtToken: signInRes.signInToken,
        role: _role.uuid,
      };

      /* End Implicit Admin Role Selection */
      const srv = getSrv();
      const content = await srv.agent?.getAccessToken(_args);
      log.log(MODULE_NAME, '"GET_ACCESS_TOKEN":', content);
      if (content && content?.accessToken) {
        // Merge signInRes (has userRoles) with content (has accessToken) so
        // whoami.service can read userRoles from storage after redirect
        const profileToStore = {
          ...(signInRes || {}),
          ...(content || {}),
        };
        if (event?.payload?.rememberMe) {
          storageSrv.set('userProfile', profileToStore, 'local');
        } else {
          storageSrv.set('userProfile', profileToStore, 'session');
        }
        return resolve({
          key: 'SIGN_IN_USER_SUCCESS',
          value: {
            ...(profileToStore || {}),
          },
        });
      } else {
        const msg = content?.error;
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        toast.error(msg);
        return reject({
          key: 'SIGN_IN_USER_FAILED',
          value: content,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      toast.error(err?.message);
      return reject({
        key: 'SIGN_IN_USER_FAILED',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
